import { UserConfigService, UserConfigProvider, UserOperProvider, HttpService } from '@lk/api'

export const makeUserConfigService = (http: HttpService, baseUrl: string) =>
  new UserConfigService(new UserConfigProvider(http, baseUrl), new UserOperProvider(http, baseUrl))
